
// 100 = rev A
// 101 = rev B, C
const firmwares = [
    { hw: [101], file: 'https://happycactusgarage.s3.us-east-2.amazonaws.com/wss_main_release_261019.hex', swVersion: 26101911 },
    { hw: [102], file: 'https://happycactusgarage.s3.us-east-2.amazonaws.com/wss_main_release_261019.hex', swVersion: 26101911 },
    { hw: [103], file: 'https://happycactusgarage.s3.us-east-2.amazonaws.com/wss_main_release_261019.hex', swVersion: 26101911 },
    { hw: [104], file: 'https://happycactusgarage.s3.us-east-2.amazonaws.com/wss_main_release_261019.hex', swVersion: 26101911 },
    { hw: [105], file: 'https://happycactusgarage.s3.us-east-2.amazonaws.com/wss_main_release_261019.hex', swVersion: 26101911 },
];

// Returns information about the firmware available for the provided hardware ID, or undefined if none is found.
export const firmwareSourceForHardware = (hwVersion: number): { swVersion: number, file: string } | undefined => {
    const result = firmwares.find(e => !!(e.hw.find(e2 => e2 === hwVersion)));

    return result ? { swVersion: result?.swVersion, file: result.file } : undefined;
};
